import { useContext } from "react";
import { MyContext } from "../App";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Link } from 'react-scroll';

const ContactMe = () => {
  const { Lang } = useContext(MyContext);
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <div id="contact" ref={ref} className="py-12 md:py-24 px-6 md:px-20 bg-gradient-to-b from-black/95 to-black border-t border-white/10 ">
      <motion.div initial={{ x: -100, opacity: 0 }}
        animate={inView ? { x: 0, opacity: 1 } : { x: -100, opacity: 0 }}
        transition={{ delay: 0.6 }}>
        <Link to="home" smooth={true} duration={1600} className="uppercase text-md text-white/90 font-normal link">
          Go To Top
        </Link>
      </motion.div>
      <motion.a initial={{ x: -100, opacity: 0 }}
        animate={inView ? { x: 0, opacity: 1 } : { x: -100, opacity: 0 }}
        transition={{ delay: 0.4 }} href="mailto:hizmi.abdelhakim@gmail.com" title="hizmi.abdelhakim@gmail.com"
        className="mt-2 md:mt-4 text-lg md:text-6xl text-white flex items-center gap-2 underline underline-offset-8 hover:text-cyan-400 transition-colors duration-1000 CosiAzureFont">
        hizmi.abdelhakim@gmail.com
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="3" stroke="currentColor" className="w-5 h-5 md:w-12 md:h-12">
          <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25" />
        </svg>
      </motion.a>
      <div className="mt-6 md:mt-14 flex flex-col md:flex-row gap-4 md:gap-28 items-center">
        <div className="flex flex-col gap-1  items-center md:items-start">
          <motion.div initial={{ opacity: 0 }}
            animate={inView ? { opacity: 1 } : { opacity: 0 }}
            transition={{ delay: 0.6 }} className="text-xs font-bold text-white/50 uppercase">
            {Lang === 'Ar' ? 'المواقع السابقة' : (Lang === "Fr" ? 'ancien portefeuille' : 'previous portfolio')}
          </motion.div>
          <div className="flex gap-3 text-center md:text-left">
            <motion.a initial={{ y: -20, opacity: 0 }}
              animate={inView ? { y: 0, opacity: 1 } : { y: -20, opacity: 0 }}
              transition={{ delay: 0.7 }} href="https://hakimhizmi-v1.netlify.app/" target="_blank" rel="noreferrer" className="text-sm font-bold text-white/80 uppercase link">
              {Lang === 'Ar' ? 'النسخة ١' : 'Version 1'}
            </motion.a>
            <motion.a initial={{ y: -10, opacity: 0 }}
              animate={inView ? { y: 0, opacity: 1 } : { y: -10, opacity: 0 }}
              transition={{ delay: 0.8 }} href="https://hakimhizmi-v2.netlify.app/" target="_blank" rel="noreferrer" className="text-sm font-bold text-white/80 uppercase link">
              {Lang === 'Ar' ? 'النسخة ٢' : 'Version 2'}
            </motion.a>
          </div>

        </div>
        <div className="flex flex-col gap-1">
          <motion.div initial={{ opacity: 0 }}
            animate={inView ? { opacity: 1 } : { opacity: 0 }}
            transition={{ delay: 0.8 }} className="text-xs font-bold text-white/50 uppercase text-center md:text-left">
            {Lang === 'Ar' ? 'وسائل التواصل الاجتماعي' : (Lang === "Fr" ? 'Réseaux sociaux' : 'Socials')}</motion.div>
          <div className="flex gap-3 text-center md:text-left">
            <motion.a initial={{ y: -10, opacity: 0 }}
              animate={inView ? { y: 0, opacity: 1 } : { y: -10, opacity: 0 }}
              transition={{ delay: 0.9 }} href="https://www.linkedin.com/in/abdelhakimhizmi/" target="_blank" rel="noreferrer" className="text-sm font-bold text-white/80 uppercase link">
              {Lang === 'Ar' ? 'لينكد إن' : 'linkedin'}</motion.a>
            <motion.a initial={{ y: -10, opacity: 0 }}
              animate={inView ? { y: 0, opacity: 1 } : { y: -10, opacity: 0 }}
              transition={{ delay: 1 }} href="https://www.instagram.com/hakiim_hizmi/" target="_blank" rel="noreferrer" className="text-sm font-bold text-white/80 uppercase link">
              {Lang === 'Ar' ? 'إنستغرام' : 'Instagram'}</motion.a>
            <motion.a initial={{ y: -10, opacity: 0 }}
              animate={inView ? { y: 0, opacity: 1 } : { y: -10, opacity: 0 }}
              transition={{ delay: 1.1 }} href="https://www.facebook.com/hasan.hizmi/" target="_blank" rel="noreferrer" className="text-sm font-bold text-white/80 uppercase link">
              {Lang === 'Ar' ? 'فيسبوك' : 'Facebook'}
            </motion.a>
          </div>
        </div>
        <div className="flex flex-col gap-1">
          <motion.div initial={{ opacity: 0 }}
            animate={inView ? { opacity: 1 } : { opacity: 0 }}
            transition={{ delay: 1.2 }} className="text-xs font-bold text-white/50 uppercase">{Lang === 'Ar' ? 'الموقع' : (Lang === "Fr" ? 'Emplacement' : 'Loaction')}
          </motion.div>
          <motion.div initial={{ y: -20, opacity: 0 }}
            animate={inView ? { y: 0, opacity: 1 } : { y: -20, opacity: 0 }}
            transition={{ delay: 1.3 }} className="text-sm font-bold text-white/80 uppercase text-center md:text-left">
            {Lang === 'Ar' ? 'أكادير' : 'Agadir'}
          </motion.div>
        </div>
        <div className="flex flex-col gap-1">
          <motion.div initial={{ scale: 0, opacity: 0 }}
            animate={inView ? { scale: 1, opacity: 1 } : { scale: 0, opacity: 0 }}
            transition={{ delay: 1.4 }} className="text-sm font-bold text-white/80 uppercase max-w-md text-center md:text-left">
            {Lang === 'Ar' ? `"رجاءً لا تنسى فلسطين في دعائك. إخوتنا وأخواتنا في غزة لا يزالون في حاجة إليها. لا تنسَهم."` :
              (Lang === "Fr" ? `"S'il vous plaît, n'oubliez pas la Palestine dans vos prières. Nos frères et sœurs à Gaza en ont encore besoin. Ne les oubliez pas."` :
                `"Please don’t forget Palestine in your duaas. Our brothers and sisters in Gaza still need it. Do not forget them."`)} 🇵🇸
          </motion.div>
          <motion.div initial={{ y: -20, opacity: 0 }}
            animate={inView ? { y: 0, opacity: 1 } : { y: -20, opacity: 0 }}
            transition={{ delay: 1.8 }} className="text-sm font-bold text-white/80 uppercase text-center md:text-left">
            {Lang === 'Ar' ? `فلسطين حرة` : (Lang === "Fr" ? `Palestine libre` : `free palestine`)}
          </motion.div>
        </div>
      </div>

    </div>
  );
};

export default ContactMe;
